var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotFound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 300 95",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "44.986%",
    x2: "100%",
    y2: "55.014%",
    id: "wq3mqnvjya"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5DBEFC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD92FE",
    offset: "100%"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M161.069 80c26.37 0 47.748 21.266 47.748 47.5S187.44 175 161.067 175c-26.37 0-47.748-21.267-47.748-47.5S134.697 80 161.07 80zm-81.856 0-41.746 57.136h25.648v-17.779h20.873v17.779H99.54v17.914H83.988V175H62.432v-19.95H11v-14.793L56.02 80h23.193zm211.46 0-41.747 57.136h25.648v-17.779h20.873v17.779H311v17.914h-15.553V175h-21.555v-19.95H222.46v-14.793L267.48 80h23.193zm-129.546 72.16c-5.96 0-10.874 1.19-14.707 3.622a2.24 2.24 0 0 0-.692 3.098 2.254 2.254 0 0 0 3.106.69c3.045-1.932 7.131-2.922 12.293-2.922 3.383 0 6.447.567 9.132 1.509.928.326 1.739.672 2.424 1.014l.342.176.247.135.265.157a2.254 2.254 0 0 0 2.989-.759 2.24 2.24 0 0 0-.772-3.148l-.196-.116-.241-.135-.287-.154-.332-.169a25.488 25.488 0 0 0-2.947-1.235c-3.145-1.103-6.709-1.763-10.624-1.763zm12.32-49.29c-4.31 0-7.803 3.476-7.803 7.764v16.48h-9.151v-16.48c0-4.288-3.494-7.763-7.804-7.763-4.31 0-7.803 3.475-7.803 7.763v28.049c0 4.287 3.494 7.763 7.804 7.763 4.31 0 7.803-3.476 7.803-7.763v-6.254h9.15v6.254c0 4.287 3.495 7.763 7.805 7.763s7.803-3.476 7.803-7.763v-28.05c0-4.287-3.494-7.762-7.803-7.762z",
    transform: "translate(-11 -80)",
    fill: "url(#wq3mqnvjya)",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not-found.522c45491e0f31a3197abfcff40fcbad.svg";
export { ForwardRef as ReactComponent };